import React from 'react';
import { Helmet } from 'react-helmet-async';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import CustomLoading from '../custom_loading';
import clickOnActivateKey from '../../../utils/keyboard';

function CommonHeader(props) {
  // title_only: the page draws its own heading; keep just the browser tab title.
  if (props.title_only) {
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{props.meta_title || props.title}</title>
        </Helmet>
        {props.loading ? <CustomLoading full_loader={props.full_loader} /> : null}
        {props.children}
      </>
    );
  }
  return (
    <div className={`${props.class_name} common-page-container`}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{props.meta_title || props.title}</title>
      </Helmet>
      {props.loading ? <CustomLoading full_loader={props.full_loader} /> : null}
      <div className="common-page-header">
        {props.show_back ? (
          <div
            className="profile-go-back"
            role="button"
            tabIndex={0}
            data-track="header-back"
            onClick={() => props.history.goBack()}
            onKeyDown={clickOnActivateKey}
          >
            <img
              src="https://s3.amazonaws.com/images.myyogateacher.com/website/home/arrow_back.png"
              alt="back"
            />
            <span>Back</span>
          </div>
        ) : null}
        <div className="common-page-title">
          {props.title}
          {props.subtitle ? <div className="common-page-subheading">{props.subtitle}</div> : null}
        </div>
      </div>
      {props.children}
    </div>
  );
}

CommonHeader.propTypes = {
  // node, not string: a page may want a badge beside its title. Widening only — every existing
  // string caller stays valid. Pass meta_title when title is a node, or the <title> tag gets it.
  title: PropTypes.node,
  subtitle: PropTypes.string,
  show_back: PropTypes.bool,
  loading: PropTypes.bool,
  full_loader: PropTypes.bool,
  class_name: PropTypes.string,
  title_only: PropTypes.bool
};

CommonHeader.defaultProps = {
  title: 'MYT',
  subtitle: '',
  show_back: false,
  loading: false,
  full_loader: false,
  class_name: '',
  title_only: false
};

export default withRouter(CommonHeader);
